import { useCallback, useEffect, useRef, useState } from "react";

function useDebouncedValue<T>(defaultValue: T, delay = 500): [T, (value: T) => void] {
    const [value, setValue] = useState<T>(defaultValue);
    const timeoutRef = useRef<NodeJS.Timeout>();
    const clearTim = () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };

    useEffect(() => {
        return () => {
            clearTim();
        };
    }, []);

    const setDebouncedValue = useCallback((value: T) => {
        clearTim();

        timeoutRef.current = setTimeout(() => {
            setValue(value);
        }, delay);
    }, [delay]);

    return [value, setDebouncedValue];
}

export default useDebouncedValue;